export default "__VITE_ASSET__zZtHwQ9c__"